import { GET_DMX_PROFILES, GET_DMX_PROFILES_SUCCESS, GET_DMX_PROFILES_ERROR } from './actionTypes';

const initialState = {
  errorGetDmxProfiles: '',
  loadingGetDmxProfiles: false,
  profiles: null,
};

const getProfiles = (state = initialState, action) => {
  switch (action.type) {
    case GET_DMX_PROFILES:
      state = { ...state, loadingGetDmxProfiles: true };
      break;
    case GET_DMX_PROFILES_SUCCESS:
      state = { ...state, loadingGetDmxProfiles: false, profiles: action.payload.profiles };
      break;
    case GET_DMX_PROFILES_ERROR:
      state = { ...state, errorGetDmxProfiles: action.payload, loadingGetDmxProfiles: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default getProfiles;
